import { createSlice } from "@reduxjs/toolkit";
import environment from "web/script/modules/environment";
import storage from "web/script/utils/storage";

export interface EventCounterSlice {
    shouldBlockFilter: boolean;
    shouldBlockAll: boolean;
}

function readFromStorage(limit): boolean {
    const blockVariant = environment.getFeature("mg_block_on_event_counter");
    const eventCounter = storage.get("eventCounter", null, true);
    if (!eventCounter) {
        return false;
    }
    if (
        eventCounter.eventCount >= limit &&
        (blockVariant === "hard_block" ||
            (blockVariant === "soft_block" && !eventCounter.hasBeenDismissed))
    ) {
        return true;
    }
    return false;
}

function updateStorage({ category, action }): void {
    // eventCounter tracks whether a block has been dismissed and how many
    // valid events have occurred this session
    const eventCounter = storage.get("eventCounter", null, true)
        ? storage.get("eventCounter", null, true)
        : {
              eventCount: 0,
              hasBeenDismissed: false,
          };
    // 5 is an arbitrary limit to count to because it's higher than any limit needed thus far
    // for filter click dont count the event on "filter close"
    if (
        (category === "app_overlay" && action === "modal_dismissed") ||
        (category === "send_to_app" && action === "continue_clicked")
    ) {
        eventCounter.hasBeenDismissed = true;
    } else if (
        eventCounter.eventCount < 5 &&
        (category !== "filter" || (category === "filter" && action !== "open"))
    ) {
        eventCounter.eventCount++;
    }

    // on every valid event update local storage
    storage.set("eventCounter", eventCounter, true);
}

function flagEnabled(flag): boolean {
    if (flag === "mg_block_on_event_counter") {
        return environment.getFeature("mg_block_on_event_counter") !== "no_block";
    }
    return false;
}

const eventCountTracker = createSlice({
    name: "eventCounter",
    initialState: {
        shouldBlockFilter: readFromStorage(2) && flagEnabled("mg_block_on_event_counter"),
        shouldBlockAll: readFromStorage(3) && flagEnabled("mg_block_on_event_counter"),
    } as EventCounterSlice,
    reducers: {
        registerEvent(state, { payload }): void {
            updateStorage(payload);
            state.shouldBlockAll = readFromStorage(3) && flagEnabled("mg_block_on_event_counter");
            state.shouldBlockFilter =
                readFromStorage(2) && flagEnabled("mg_block_on_event_counter");
        },
    },
});

export const { registerEvent } = eventCountTracker.actions;
export default eventCountTracker.reducer;
